// avstemming-other-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avh.common.close': 'Close',
  'avh.common.requestDocs': 'Ask the client for documentation',
  'avh.common.countOf': '{done} of {total}',
  'avh.common.bookedBalance': 'Booked balance',
  'avh.common.specDiff': 'Specification difference',
  'avh.common.docsMissing': 'Documentation missing',
  'avh.common.assessmentRemaining': 'Assessment outstanding',
  'avh.common.account': 'Account',
  'avh.common.status': 'Status',
  'avh.common.notSet': 'Not set',
  'avh.common.itemsOver90': 'Items over 90 days',
  'avh.common.itemsOverThreshold': 'Items over the threshold',
  'avh.common.materialityThreshold': 'Materiality threshold',
  'avh.common.openAdjustments': 'Open reconciliation items',
  'avh.common.professionalConfirmation': 'Professional confirmation',
  'avh.common.reconciliation': 'Reconciliation',
  'avh.common.reconciliationItems': 'Reconciliation items',
  'avh.common.matches': 'Matches',
  'avh.common.confirmed': 'Confirmed',
  'avh.common.conclusion': 'Conclusion',
  'avh.common.overallStatus': 'Overall status',
  'avh.common.remainingRisk': 'Remaining risk',
  'avh.common.followUpNext': 'Follow-up next period',
  'avh.common.action': 'Action',
  'avh.common.professionalChecklist': 'Professional checklist',
  'avh.common.openItems': 'Open items',
  'avh.common.accountOverview': 'Account overview',
  'avh.common.checklist': 'Checklist',
  'avh.common.postings.one': '{count} posting',
  'avh.common.postings.other': '{count} postings',
  'avh.common.items.other': '{count} items',
  'avh.common.items.one': '{count} item',
  'avh.assess.notAssessed': 'Not assessed',
  'avh.assess.okGenuine': 'OK – the item is genuine and correctly recorded',
  'avh.assess.unspecifiedBalance': 'Unspecified balance',
  'avh.assess.counterpartyMissing': 'Counterparty missing',
  'avh.assess.wrongAccrual': 'Incorrect accrual',
  'avh.assess.misclassified': 'Misclassified account',
  'avh.assess.notGenuine': 'Not a genuine item',
  'avh.assess.settledAfter': 'Settled after period end',
  'avh.assess.awaitingDocs': 'Awaiting documentation',
  'avh.assess.awaitingClient': 'Awaiting the client',
  'avh.assess.writeDown': 'Write-down under assessment',
  'avh.assess.writeOff': 'To be written off as a loss',
  'avh.assess.followUpNext': 'Follow up next period',
  'avh.level.documented': 'Documentation available',
  'avh.level.documentedHint': 'Is there an invoice, agreement, payment confirmation or other basis that shows what the item is?',
  'avh.level.existence': 'Existence confirmed',
  'avh.level.existenceHint': 'Is the receivable or obligation still genuine on the reconciliation date, and not just booked?',
  'avh.level.subsequent': 'Subsequent payment or settlement checked',
  'avh.level.subsequentHint': 'Has the item been settled after the period end, or has it been checked that it has not?',
  'avh.level.recoverability': 'Recoverability assessed',
  'avh.level.recoverabilityHint': 'Will the amount be received, and has the need for a write-down been assessed?',
  'avh.flag.over90': 'Over 90 days',
  'avh.flag.unusualSign': 'Unusual sign',
  'avh.flag.roundAmount': 'Round amount',
  'avh.flag.noMovement': 'No movement in the period',
  'avh.flag.manualPeriodEnd': 'Manual posting at period end',
  'avh.status.reconciled': 'Reconciled',
  'avh.status.documentedPending': 'Documented · assessment outstanding',
  'avh.status.followUp': 'Needs follow-up',
  'avh.status.critical': 'Critical – must be resolved',
  'avh.status.toAssess': 'Needs assessment',
  'avh.dr.accountLine': 'Account {id} {name} · {postings}',
  'avh.dr.closingBalance': 'Closing balance',
  'avh.dr.originalDate': 'Original date',
  'avh.dr.lastMovement': 'Last movement',
  'avh.dr.age': 'Age',
  'avh.dr.materiality': 'Materiality',
  'avh.dr.noThreshold': 'No threshold set',
  'avh.dr.overThreshold': 'Over the threshold',
  'avh.dr.underThreshold': 'Under the threshold',
  'avh.dr.controlLevels': 'Control levels',
  'avh.dr.levelsNote': 'The item is already specified — it has been read from the general ledger. The four above are something else, and none of them replaces the others.',
  'avh.dr.assessment': 'Assessment',
  'avh.dr.rationale': 'Professional rationale',
  'avh.dr.rationaleRequired': 'Professional rationale (required)',
  'avh.dr.rationalePlaceholder': 'What does the item concern, who is the counterparty, and what is the assessment based on?',
  'avh.dr.actionPlaceholder': 'E.g. Obtain the agreement from the client, reclassify to 1579, or check the incoming payment',
  'avh.dr.followUpDeadline': 'Follow-up deadline',
  'avh.dr.lastAssessed': 'Last assessed: {trail}',
  'avh.dr.needsRationale': 'This assessment requires a rationale.',
  'avh.dr.saveAssessment': 'Save assessment',
  'avh.cp.counterparty': 'Counterparty',
  'avh.cp.basis': 'Original basis and documentation',
  'avh.cp.dueDate': 'Due date or expected settlement date',
  'avh.cp.subsequent': 'Subsequent payment or settlement',
  'avh.cp.age': 'Age and movement since the previous period',
  'avh.cp.recoverable': 'Whether the amount is still genuine and recoverable',
  'avh.sec.thresholdPositive': 'Enter the materiality threshold as a positive number.',
  'avh.sec.thresholdBasisRequired': 'Enter what the threshold is based on. Without a rationale it is just a number.',
  'avh.sec.basis': 'Basis',
  'avh.sec.setBy': 'Set by',
  'avh.sec.setOn': 'Set on',
  'avh.sec.thresholdNote': 'The threshold says which items must be assessed individually. It does not switch off any control — all open items must still be processed before the area can be sent for review.',
  'avh.sec.noThresholdNote': 'No materiality threshold has been set for this period. All items are treated alike. The threshold is the firm\'s own professional judgement — the app suggests no rate.',
  'avh.sec.amountInKroner': 'Amount in kroner',
  'avh.sec.basisPlaceholder': 'What is the threshold based on? E.g. 5 % of profit before tax',
  'avh.sec.basisAria': 'Basis for the materiality threshold',
  'avh.sec.saveThreshold': 'Save threshold',
  'avh.sec.removeThreshold': 'Remove threshold',
  'avh.sec.cancel': 'Cancel',
  'avh.sec.changeThreshold': 'Change threshold',
  'avh.sec.setThreshold': 'Set materiality threshold',
  'avh.sec.hideRisk': 'Hide risk indicators to consider',
  'avh.sec.showRisk': 'Show risk indicators to consider',
  'avh.sec.type': 'Type',
  'avh.sec.specified': 'Specified',
  'avh.sec.documented': 'Documented',
  'avh.sec.unverified': 'Not verified',
  'avh.sec.oldestItem': 'Oldest item',
  'avh.sec.notSpecified': 'Not specified',
  'avh.sec.openAccount': 'Open account',
  'avh.sec.checkedAgainst': 'Checked against',
  'avh.sec.flaggedItems': 'Flagged items',
  'avh.sec.openingBalance': 'Opening balance',
  'avh.sec.movementInPeriod': 'Movement in the period',
  'avh.sec.specDriftAlert': 'The sum of the specified items is {specified}, while the general ledger shows {booked}. The difference of {diff} is balance that has not been specified — usually an opening balance that was imported without underlying postings.',
  'avh.sec.showOpenItems': 'Show open items',
  'avh.sec.openAccountWork': 'Open the account work',
  'avh.sec.noAccounts': 'No accounts have been added to other balance in this period.',
  'avh.sec.itemsIntro': 'The items have been read from the general ledger and grouped by what they relate to, from the start of the accounts up to and including {date}.',
  'avh.sec.settledOne': '{count} group has been settled and is not shown.',
  'avh.sec.settledMany': '{count} groups have been settled and are not shown.',
  'avh.sec.allAccountsInArea': 'All accounts in the area',
  'avh.sec.resetFilters': 'Reset filters',
  'avh.sec.counterpartyDescription': 'Counterparty / description',
  'avh.sec.lastMovementLine': ' · last movement {date}',
  'avh.sec.actionLine': 'Action: {action}',
  'avh.sec.viewAssessment': 'View assessment',
  'avh.sec.assess': 'Assess',
  'avh.sec.requestDocsShort': 'Request documentation',
  'avh.sec.noMatchingItems': 'No items match the filters.',
  'avh.sec.noOpenItems': 'No open items on the accounts in this area.',
  'avh.sec.sumSpecified': 'Sum of specified items',
  'avh.sec.ageDistribution': 'Age distribution',
  'avh.sec.withoutDocs': 'Without documentation',
  'avh.doc.notRecorded': 'Not recorded',
  'avh.doc.unknown': 'Unknown',
  'avh.doc.title': 'Documentation and audit trail',
  'avh.doc.existing': 'Existing documents',
  'avh.doc.checked': 'Checked documents',
  'avh.doc.unchecked': 'Unchecked documents',
  'avh.doc.itemsWithoutDocs': 'Items without documentation',
  'avh.doc.document': 'Document',
  'avh.doc.source': 'Source',
  'avh.doc.link': 'Link',
  'avh.doc.controlStatus': 'Control status',
  'avh.doc.other': 'Other',
  'avh.doc.client': 'The client',
  'avh.doc.firm': 'The firm',
  'avh.doc.linked': 'Linked',
  'avh.doc.notLinked': 'Not linked',
  'avh.doc.checkedOne': 'Checked',
  'avh.doc.uncheckedOne': 'Not checked',
  'avh.doc.view': 'View',
  'avh.doc.reopenCheck': 'Reopen check',
  'avh.doc.markChecked': 'Mark as checked',
  'avh.doc.empty': 'No documents have been attached to other balance in this period. Use the documents tab in the right-hand panel to attach them.',
  'avh.doc.missingRequirements': 'Missing documentation requirements',
  'avh.doc.specCheck': 'Specification check',
  'avh.doc.difference': 'Difference',
  'avh.doc.sumSpecifiedOpen': 'Sum of specified open items',
  'avh.doc.notFullySpecified': 'The balance is not fully specified. The difference is usually an opening balance that was imported without underlying postings — it must be specified manually on the account.',
  'avh.doc.docAssessmentCheck': 'Documentation and assessment check',
  'avh.doc.notFullyDocumented': 'Not fully documented',
  'avh.doc.fullyAssessed': 'Fully assessed',
  'avh.doc.documentedBalance': 'Documented balance',
  'avh.doc.fullyAssessedBalance': 'Fully assessed balance',
  'avh.doc.balanceSummary': '{documented} has attached documentation. Of this, {pending} has not been fully assessed for recoverability. The fully professionally assessed balance is therefore {assessed}.',
  'avh.doc.autoCheck': 'Automatic check',
  'avh.doc.doneByPlumme': 'Performed by Plumme',
  'avh.doc.autoCheckText': 'Plumme has read the general ledger up to and including {date} and checked that the sum of the specified items ({specified}) matches the booked balance ({booked}). This is a technical check — it does not confirm that the documentation is sufficient, that old items are genuine and recoverable, or that the reconciliation is ready for review.',
  'avh.doc.notConfirmed': 'Not confirmed',
  'avh.doc.confirmText': 'A person must confirm that the documentation is sufficient, that old items are genuine and recoverable, that the accruals are professionally correct, that all material deviations have been dealt with, and that the reconciliation is ready for review.',
  'avh.doc.confirmSavedAs': 'The confirmation is saved as the control point “{label}” in the professional checklist — in one place, so the reviewer finds it where they look.',
  'avh.doc.cannotConfirm': 'Cannot be confirmed until missing documentation, outstanding assessments and the specification difference have been dealt with.',
  'avh.doc.confirmCheck': 'Confirm professional check',
  'avh.doc.pointMissing': 'The control point does not exist in this period\'s checklist.',
  'avh.adj.pickAccount': 'Select the account the item relates to.',
  'avh.adj.enterAmount': 'Enter an amount.',
  'avh.adj.enterReason': 'Enter what the item is due to. Without a reason it does not count as explained.',
  'avh.adj.description': 'Description',
  'avh.adj.date': 'Date',
  'avh.adj.amount': 'Amount',
  'avh.adj.classification': 'Classification',
  'avh.adj.missingReason': 'Missing rationale',
  'avh.adj.resolved': 'Resolved',
  'avh.adj.open': 'Open',
  'avh.adj.markUnresolved': 'Mark unresolved',
  'avh.adj.markResolved': 'Mark resolved',
  'avh.adj.delete': 'Delete',
  'avh.adj.reasonPlaceholder': 'What is the item due to?',
  'avh.adj.chooseAccount': 'Choose account',
  'avh.adj.add': 'Add',
  'avh.adj.none': 'No reconciliation items registered.',
  'avh.adj.note': 'The items are proposed corrections for approval — nothing is booked automatically.',
  'avh.derived.documented': 'All open items have documentation',
  'avh.derived.existence': 'The existence of all open items has been confirmed',
  'avh.derived.subsequent': 'Subsequent settlement has been checked',
  'avh.derived.recoverability': 'The recoverability of all open items has been assessed',
  'avh.derived.old': 'Items older than 90 days have been fully assessed',
  'avh.derived.noCounterparty': 'Items without an identified counterparty have been resolved',
  'avh.derived.unusualSign': 'Items with an unusual sign have been investigated',
  'avh.derived.manualPeriodEnd': 'Manual period-end postings have been assessed',
  'avh.ck.noPoints': 'No control points have been defined for other balance in this period.',
  'avh.ck.titleReadOnly': 'Professional checklist (preparer\'s, read-only)',
  'avh.ck.pointsNote': 'The points apply to the whole area. A tick is saved on all accounts in other balance.',
  'avh.ck.groupItems': 'Items requiring action',
  'avh.ck.processedOf': '{done} of {total} processed',
  'avh.ck.notApplicable': 'Not applicable this period',
  'avh.ck.overThreshold': ' · {count} over the materiality threshold',
  'avh.ck.followsAssessments': 'Follows from the assessments',
  'avh.ck.groupPerAccount': 'Per account',
  'avh.ck.itemsAssessed': '{done} of {total} items fully assessed',
  'avh.ck.noOpenItems': 'No open items',
  'avh.ck.notSpecifiedAmount': ' · not specified: {amount}',
  'avh.ck.noAccounts': 'No accounts in the area.',
  'avh.ck.groupOverall': 'Overall professional assessments',
  'avh.ck.groupReady': 'Readiness',
  'avh.ck.performedBy': 'Performed by {name} · ',
  'avh.ck.pointsDone': '{done} of {total} control points completed',
  'avh.bl.unspecified': 'The balance is not fully specified — {amount} is unexplained',
  'avh.bl.docsMissing': 'Underlying documentation is missing for {amount}',
  'avh.bl.existenceOne': 'The existence of {count} item has not been confirmed',
  'avh.bl.existenceMany': 'The existence of {count} items has not been confirmed',
  'avh.bl.recoverability': 'The recoverability of {amount} must be assessed',
  'avh.bl.oldOne': '{count} item over 90 days has not been fully processed',
  'avh.bl.oldMany': '{count} items over 90 days have not been fully processed',
  'avh.bl.adjustmentOne': '{count} reconciliation item is open',
  'avh.bl.adjustmentMany': '{count} reconciliation items are open',
  'avh.bl.pointOne': '{count} control point is not completed',
  'avh.bl.pointMany': '{count} control points are not completed',
  'avh.bl.criticalNoReason': '{count} critical deviation lacks a rationale',
  'avh.concl.title': 'Conclusion and approval',
  'avh.concl.accountsInArea': 'Accounts in the area',
  'avh.concl.documentedNotAssessed': 'Documented but not fully assessed',
  'avh.concl.incompletePoints': 'Incomplete control points',
  'avh.concl.done': 'Done',
  'avh.concl.missing': 'Missing',
  'avh.concl.notReady': 'Not ready for review',
  'avh.concl.ready': 'Ready for review',
  'avh.concl.placeholder': 'What do the balances consist of, what has been documented and assessed, and what remains?',
  'avh.concl.savedAs': 'Saved as the rationale on the control point “{label}”.',
  'avh.concl.periodNotLocked': 'The period is not locked — vouchers can still be posted and change the basis.',
  'avh.concl.periodNotEnded': 'The period has not ended. The reconciliation applies to the basis as of {date} and must be repeated after the period end.',
  'avh.concl.nothingLeft': 'Nothing remains that prevents the area from being sent for review. The area has no external balance — that the specification adds up to the general ledger is a technical check, and it is the assessment of each item that carries the conclusion.',
  'avh.concl.noFollowUps': 'No assessments are marked for follow-up next period.',
  'avh.concl.followed': 'Followed up',
  'avh.concl.noAction': 'No action noted',
  'avh.concl.deadline': ' · Deadline {date}',
  'avh.concl.openAssessment': 'Open assessment',
  'avh.concl.sendArea': 'Send the area for review',
  'avh.concl.leftOne': 'One thing remains before the area can be sent.',
  'avh.concl.leftMany': '{count} things remain before the area can be sent.',
  'avh.quick.needsAssessment': 'Needs assessment',
  'avh.quick.allOpen': 'All open',
  'avh.quick.withoutDocs': 'Without documentation',
  'avh.quick.overThreshold': 'Over the materiality threshold',
  'avh.quick.noMovement': 'Without movement',
  'avh.quick.manualPeriodEnd': 'Manual at period end',
  'avh.quick.fullyAssessed': 'Fully assessed',
  'avh.pg.noRecAccount': 'Other balance has no reconciliation account in this period.',
  'avh.pg.accountsCount': '{count} accounts',
  'avh.pg.toAssess': '{count} to assess',
  'avh.pg.documentation': 'Documentation',
  'avh.pg.amountMissing': '{amount} missing',
  'avh.pg.complete': 'Complete',
  'avh.pg.amountUnspecified': '{amount} unspecified',
  'avh.pg.openCount': '{count} open',
  'avh.pg.notReady': 'Not ready',
  'avh.pg.areaLabel': 'Other balance',
  'avh.pg.hintUnassessed': '{count} open items have not been fully assessed.',
  'avh.pg.hintAllAssessed': 'All open items have been fully assessed.',
  'avh.pg.title': 'Other balance — specification of the residual accounts',
  'avh.pg.dataThrough': ' · Data basis up to and including {date}',
  'avh.pg.responsible': ' · Responsible {name}',
  'avh.pg.materialityLine': ' · Materiality threshold {value}',
  'avh.pg.notSetLower': 'not set',
  'avh.pg.needAssessment': '{count} items require assessment',
  'avh.pg.noOpenIssues': 'No open issues',
  'avh.pg.scope': 'The area covers the balance sheet accounts that are not reconciled in their own areas for bank, customers, suppliers, payroll, duties, tax, assets, loans or equity.',
  'avh.pg.accountCount': 'Number of accounts',
  'avh.pg.totalAssets': 'Total booked asset balance',
  'avh.pg.totalLiabilities': 'Total booked liability balance',
  'avh.pg.openItemCount': 'Number of open items',
  'avh.pg.itemsOlder90': 'Items older than 90 days',
  'avh.pg.settledItems': 'Settled items',
  'avh.pg.noExternalBalance': 'Other balance has no external balance. The specification and the general ledger are both the company\'s own sources, and an item that was never genuine appears in both. Existence, counterparty and recoverability are therefore confirmed item by item — not by two numbers being equal.',
  'avh.pg.periodOverNotLocked': 'The period is over but not locked. Vouchers can still be posted and change the basis the reconciliation rests on. Lock the period when it is finished.',
  'avh.pg.periodNotEnded': 'The period has not ended. This is a preliminary reconciliation as of {date}. The rest of the month\'s vouchers do not exist yet, and the final general ledger must be fetched after the period end before the reconciliation can be completed.',
  'avh.pg.noAccountsMove': 'No accounts have been added to other balance in this period. Accounts that do not belong here are moved to their own area from the account overview.',
  'avh.pg.accountingData': 'Accounting data',
  'avh.pg.fetchedFrom': 'Fetched from the trial balance and the general ledger',
  'avh.pg.perDate': ' as of {date}',
  'avh.pg.kpiAssets': 'Booked asset balance',
  'avh.pg.kpiLiabilities': 'Booked liability balance',
  'avh.pg.kpiPrevious': 'Balance previous period',
  'avh.pg.kpiChange': 'Change',
});
